<template>
  <div class="bc__ui__tabs">
      <ul>
          <li v-for="(tab, i) in this.tabs" :key="i" :class="{'active': tab.active}" @click="switchTab(i)">
              <a>
                  {{tab.name}}
                  <span v-if="tab.num">{{tab.num}}</span>
              </a>
          </li>
      </ul>
  </div>
</template>

<style lang="scss" scoped >

</style>

<script>
export default {

    props: [
        'tabs'
    ],

    methods: {
        switchTab(i) {
            this.$emit('switchTabControl', i);
        }
    }
};

</script>
